import { Store, Home, MapPin, Warehouse } from "lucide-react";
import PropertyCard from "@/components/PropertyCard";
import { useLocation, useNavigate } from "react-router-dom";

// CATEGORIAS BASE
const baseCategories = [
  { id: "economico", name: "Accesibles", icon: Store },
  { id: "local", name: "Locales", icon: Store },
  { id: "oficina", name: "Oficinas / Consultorios", icon: Store },
  { id: "casa", name: "Casas para negocio", icon: Home },
  { id: "terreno", name: "Terrenos", icon: MapPin },
  { id: "bodega", name: "Bodegas", icon: Warehouse },
];

export const PropertyGrid = ({
  properties,
  loading,
  selectedCategory,
  onCategoryChange,
  onPropertyClick,
  title,
  subtitle,
  priceText,
  showCategories = true,
  onlyEconomicos = false,
  hideEconomicos = false,
  showRibbon = false
}) => {

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = `${location.pathname}${location.search}`;
  console.log("showRibbon:", showRibbon);

  const normalize = (text) =>
    (text || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

  // 🔥 CONTROL VISUAL DE CATEGORÍAS
  const categories = onlyEconomicos
    ? baseCategories.filter((c) => c.id === "economico")
    : baseCategories.filter((c) => !(hideEconomicos && c.id === "economico"));

  const visibleCategories = selectedCategory
    ? categories.filter((c) => c.id === normalize(selectedCategory))
    : categories;

  // 🔥 FIX PRINCIPAL: bloqueo total de tipos
const finalProperties = properties || [];

  return (
    <div className="w-full px-2 sm:px-3 lg:px-4">

      {/* HEADER */}
      {(title || subtitle) && (
        <div className="mb-4 text-center">
          {title && <h2 className="text-3xl font-bold uppercase">{title}</h2>}
          {subtitle && <p className="text-gray-500 uppercase">{subtitle}</p>}
        </div>
      )}

      {/* CATEGORÍAS */}
      {showCategories && (
        <div className="mb-3 flex flex-wrap items-center gap-1">

          {visibleCategories.map((category) => {
            const isActive =
              normalize(selectedCategory) === category.id;

            return (
              <button
                key={category.id}
                onClick={() => onCategoryChange(category.id)}
                className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-medium ${
                  isActive
                    ? "bg-[#0056D2] text-white"
                    : "bg-white border text-gray-700"
                }`}
              >
                {category.name}
              </button>
            );
          })}

        </div>
      )}

      {/* GRID */}
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 w-full">

          {finalProperties.map((property) => (
          <PropertyCard
  key={property.id}
  property={property}
  allProperties={finalProperties}
  selectedCategory={selectedCategory}
  showRibbon={showRibbon ?? false}
 onClick={(targetProperty = property) =>
   navigate(`/propiedad/${targetProperty.id}`, {
     state: { from: currentPath },
   })
 }
/>
          ))}

        </div>
      )}

      <div className="mt-3 text-center text-[10px] text-gray-500">
        {finalProperties.length} propiedades
      </div>

    </div>
  );
};

export default PropertyGrid;
